/**
 * 通讯录多选表格：翻页/回勾时的 selection 同步辅助。
 * Element UI 在 data 切换时会先抛空 selection-change，若不加锁会把当页已选从 Map 里删掉（表现为隔页未勾选）。
 * 创建于 2026-10-29
 */

/**
 * 翻页或替换表格数据前调用，锁住 selection-change。
 * @param {Vue} vm
 * @param {string} [flagKey='personScopeSyncingTable']
 */
export function lockPersonScopeSelectionSync(vm, flagKey = 'personScopeSyncingTable') {
  if (!vm) return
  vm[flagKey] = true
}

/**
 * 回勾完成后解锁（双 nextTick，挡住 Element 异步补发的空选事件）。
 * @param {Vue} vm
 * @param {string} [flagKey='personScopeSyncingTable']
 */
export function unlockPersonScopeSelectionSync(vm, flagKey = 'personScopeSyncingTable') {
  if (!vm || !vm.$nextTick) {
    if (vm) vm[flagKey] = false
    return
  }
  vm.$nextTick(() => {
    vm.$nextTick(() => {
      vm[flagKey] = false
    })
  })
}

/**
 * 按已选判定回勾当前页行。
 * @param {object} opts
 * @param {Vue} opts.vm
 * @param {string} opts.tableRef - $refs 上的表格名
 * @param {Array} opts.rows - 当前页行
 * @param {(row: object) => boolean} opts.isSelected
 * @param {string} [opts.flagKey='personScopeSyncingTable']
 */
export function syncPersonScopeElTableSelection(opts) {
  const vm = opts && opts.vm
  const tableRef = (opts && opts.tableRef) || 'personScopeTable'
  const rows = (opts && opts.rows) || []
  const isSelected = opts && opts.isSelected
  const flagKey = (opts && opts.flagKey) || 'personScopeSyncingTable'
  if (!vm || typeof isSelected !== 'function') return

  const table = vm.$refs[tableRef]
  if (!table) {
    vm[flagKey] = false
    return
  }

  vm[flagKey] = true
  table.clearSelection()
  rows.forEach((row) => {
    if (isSelected(row)) table.toggleRowSelection(row, true)
  })
  unlockPersonScopeSelectionSync(vm, flagKey)
}
